module.exports = __webpack_public_path__ + "img/phone-contact.1de57cfc.webp";